export const MSG_INVOICE_CREATING = {
  key: 'invoiceCreating',
  kind: 'info',
};

export const MSG_INVOICE_CREATE_ERROR = {
  key: 'invoiceCreateError',
  kind: 'error',
};
export const MSG_INVOICE_EET_EDIT_BLOCKED = {
  key: 'invoiceEetEditBlocked',
  kind: 'info',
  button: {
    action: '',
    key: 'invoiceEetEditBlockedButton',
  },
};
export const MSG_INVOICE_EET_REGISTER = {
  key: 'invoiceEetRemindRegister',
  kind: 'info',
};
